/* eslint-disable no-param-reassign */
import { fieldYesToAllAdvisories } from '../../utils/constant';
import { setItem, removeItem } from '../../utils';
// * Auto select all adivsories to YES * when Yes to ALL is selected
export const autoSelectAllAdvisories = (
  name,
  fields,
  checked,
  setFormFields
) => {
  // const fieldYesToAllAdvisories = 'fieldYesToAllAdvisories';
  if (name === fieldYesToAllAdvisories) {
    const newFields = { ...fields };

    Object.keys(newFields).forEach(field => {
      if (field.includes('customerAdvisories') && newFields[field].isVisible) {
        // Initialize properties if they are undefined
        if (typeof newFields[field].checked === 'undefined') {
          newFields[field].checked = false;
        }
        if (typeof newFields[field].value === 'undefined') {
          newFields[field].value = false;
        }

        newFields[field].checked = checked;
        newFields[field].value = checked;

        const element = document.querySelector(`input[name="${field}"]`);
        if (element) {
          element.checked = checked;
        }
      }
    });

    setFormFields(newFields);
  }
};
export const permitNumbers = (
  permitNumber,
  fields,
  fieldName,
  fieldAccountDetailsVulcan,
  fieldExpirationKeyVulcan,
  fieldsKeyLocalStorage,
  obj
) => {
  if (!permitNumber) {
    if (fields && fields.formStepFields) {
      fields.formStepFields.forEach((el, index) => {
        if (el.fields.name === fieldExpirationKeyVulcan) {
          obj = el;
          setItem(fieldsKeyLocalStorage, obj);
          // eslint-disable-next-line no-param-reassign
          delete fields.formStepFields[index];
        }
      });
    }
  } else if (
    localStorage.getItem(fieldsKeyLocalStorage) &&
    fields &&
    fields.formStepFields &&
    fieldName === fieldAccountDetailsVulcan
  ) {
    fields.formStepFields.push(
      JSON.parse(localStorage.getItem(fieldsKeyLocalStorage))
    );
    removeItem(fieldsKeyLocalStorage);
  }
};
